import React from "react";
import PropTypes from "prop-types";
import {
  getPathogenicDbs,
  getUncertainDbs,
  getBenignDbs,
  getMetaScoresDbs,
  countBenignDbsSum,
  countPathogenicDbsSum,
  countUncertainDbsSum,
} from "../helpers/genericHelpers";
import { HorizontalStackedBar } from "../../../../../../components/atoms";
import HelperText from "../../../../../../components/atoms/HelperText";
import {
  uncertainSignificanceColor,
  benignStrongColor,
  pathogenicStrongColor,
} from "../../../../../../common/helpers/colors";
import InSilicoPredictionsScoresTable from "./InSilicoPredictionsScoresTable";

const MetaScores = ({ insilicoDbs, cardsUIEnabled }) => {
  const metaScoresDbs = getMetaScoresDbs(insilicoDbs);
  const pathogenicDbs = getPathogenicDbs(metaScoresDbs);
  const uncertainDbs = getUncertainDbs(metaScoresDbs);
  const benignDbs = getBenignDbs(metaScoresDbs);
  const pathogenicDbsSum = countPathogenicDbsSum(metaScoresDbs);
  const benignDbsSum = countBenignDbsSum(metaScoresDbs);
  const uncertainDbsSum = countUncertainDbsSum(metaScoresDbs);

  const metaScoresPredictionsBarData = [
    {
      value: pathogenicDbsSum,
      color: pathogenicStrongColor,
      text: `${pathogenicDbsSum}`,
      renderDataArray: pathogenicDbs.map((i) => i.name),
    },
    {
      value: uncertainDbsSum,
      color: uncertainSignificanceColor,
      text: `${uncertainDbsSum}`,
      renderDataArray: uncertainDbs.map((i) => i.name),
    },
    {
      value: benignDbsSum,
      color: benignStrongColor,
      text: `${benignDbsSum}`,
      renderDataArray: benignDbs.map((i) => i.name),
    },
  ];

  const metaScoresExists =
    metaScoresPredictionsBarData
      .map((elem) => elem.value)
      .reduce((prev, cur) => prev + cur, 0) > 0;

  if (!metaScoresExists) return null;

  return (
    <>
      <div className="tw-flex tw-mx-auto tw-pb-2">
        <label className="tw-mt-2 tw-font-bold">Meta scores</label>
        <div className="tw-mt-2">
          <HelperText
            title=""
            customText="These predictors determine a pathogenicity based on the combined evidence from multiple other in-silico predictors. Note: Engines are assigned a prediction points score based on the strength of the calibrated prediction. Supporting: 1 point. Moderate: 2 points. Strong: 4 points. Very Strong: 8 points"
          />
        </div>
        <div className="tw-scontainer tw-min-w-80 tw-max-w-160 tw-flex-grow tw-text-white tw-ml-4">
          <HorizontalStackedBar
            className="tw-h-8 tw-text-xs"
            data={metaScoresPredictionsBarData}
            forceDisabledToolTip={false}
          />
        </div>
        <div className="tw-flex-grow" />
      </div>
      <InSilicoPredictionsScoresTable
        insilicoDbs={getMetaScoresDbs(insilicoDbs).sort((a, b) =>
          a.name.localeCompare(b.name)
        )}
        cardsUIEnabled={cardsUIEnabled}
      />
    </>
  );
};

MetaScores.propTypes = {
  insilicoDbs: PropTypes.arrayOf(PropTypes.shape({})),
  cardsUIEnabled: PropTypes.bool,
};

MetaScores.defaultProps = {
  insilicoDbs: null,
  cardsUIEnabled: false,
};

export default MetaScores;
